export default __webpack_public_path__ + "static/media/B-T-BRIDGE.8a48facf.svg";